export class MenuItem {
    public name : string;
    public link : string;
    public id : number;
}


// WEBPACK FOOTER //
// ./src/providers/dto/menu-item.ts